import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const getTaxRatesState = (state: AppState) => state.taxRates;

export const taxRatesSelector = createSelector(getTaxRatesState, state => state.taxRates);
export const allTaxRatesSelector = createSelector(getTaxRatesState, state => state.allTaxRates);
